export default __webpack_public_path__ + "static/media/MarketRealCase2-moblie.dc5cafe0.jpg";